<div class="service-address-selector-holder">
  <mat-toolbar>
    <span>Service Locations</span>
    <span class="service-address-title-spacer"></span>
    <button mat-icon-button aria-label="Add Service Location" (click)="openPopup()">
      <mat-icon>add</mat-icon>
    </button>
  </mat-toolbar>

  @if (entries && entries.length > 0) {
  @for (entry of entries; track entry) {
  @if (entry.serviceAddress) {
  <mat-card class="service-address-card">
    <mat-card-header>
      <mat-card-title>
        {{entry.serviceAddress.address?.street_address}}
        @if (entry.serviceAddress.address?.unit_number) { #{{entry.serviceAddress.address?.unit_number}} }
      </mat-card-title>
      <mat-card-subtitle>
        {{entry.serviceAddress.address?.city}}, {{entry.serviceAddress.address?.state}} {{entry.serviceAddress.address?.zip_code}}
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <mat-selection-list [multiple]="true"
        (selectionChange)="onServiceSelectionListChange(entry, $event)">
        @for (service of serviceOptions; track service) {
        <mat-list-option [value]="service.id" [selected]="entry.selectedServiceIds.includes(service.id)">
          {{service.title}}
        </mat-list-option>
        }
      </mat-selection-list>
    </mat-card-content>
    <mat-card-actions>
      <button mat-button color="warn" (click)="removeEntry(entry)">
        <mat-icon>delete</mat-icon> Remove
      </button>
    </mat-card-actions>
  </mat-card>
  }
  }
  }
  @else {
  <div class="blank-service-address-slate">No Service Locations added yet</div>
  }
</div>
